import * as React from "react"
import { useTranslation } from "react-i18next"

import DeleteButton from "Catalog/Edit/shared/components/CatalogToolbar/DeleteButton"
import NewButton from "Catalog/Edit/shared/components/CatalogToolbar/NewButton"
import CatalogToolbar from "Catalog/shared/components/CatalogToolbar"
import useCatalogNavigation from "Catalog/shared/hooks/useCatalogNavigation"
import useEditor from "shared/hooks/useEditor"
import useNavigateNoUpdate from "shared/hooks/useNavigateNoUpdate"
import { IDeal } from "shared/hubrise/models"

interface ToolbarProps {
  deal?: IDeal
}

const Toolbar = ({ deal }: ToolbarProps): JSX.Element => {
  const { t } = useTranslation()
  const navigate = useNavigateNoUpdate()
  const { editor } = useEditor()
  const { catalogNavigation } = useCatalogNavigation()

  const handleCreate = (name: string): void => {
    const newDeal = editor.deal.add(deal, { name })
    navigate(catalogNavigation.editPath("deal", newDeal.id))
  }

  const handleDelete = (deal: IDeal) => {
    navigate(catalogNavigation.editNextPath("deals"))
    editor.deal.delete(deal.id)
  }

  const commandActions = (
    <>
      <NewButton handleCreate={handleCreate} labelAndTitle={t("toolbar.new.deal")} />
      <DeleteButton item={deal} handleDelete={handleDelete} />
    </>
  )

  return <CatalogToolbar commandActions={commandActions} />
}

export default Toolbar
